import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import styles from './Search.module.less';
import Loading from '../components/Loading';
import LoadError from '../components/LoadError';
import Filter from './Filter';
import List from './List';
import { GAME_CLASSES, GAME_CLASS_APPS_LIST } from '../../../config';
import { createAxios } from '../../../utils/utils';
import useLog from '../hooks/useLog';
import { scrollUse } from '../../../actions/game';

const LIMIT = 30;

export default ({ source }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [report, track] = useLog();
  const query = new URLSearchParams(useLocation().search);
  const [fold, setFold] = useState(true);
  const [classes, setClasses] = useState([]);
  const [code, setCode] = useState(null);
  const [childCode, setChildCode] = useState(null);
  const [apps, setApps] = useState([]);

  const [hasError, setHasError] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [loadmore, setLoadmore] = useState(Date.now());

  const $this = useRef({
    fetching: false,
    isEnd: false,
    skip: 0,
  });

  const toggleCode = useCallback(_code => {
    setHasError(false)
    setFold(true);
    setApps([]);
    $this.current = {
      fetching: false,
      isEnd: false,
      skip: 0,
    };
    setCode(_code);
    let _childCode = classes.find(cls => cls.code === _code).childClassList[0].childCode
    setChildCode(_childCode);

    report('C', source, {
      source: `${source}||${_code}||${_childCode}`
    })
  }, [classes]);

  const toggleChildCode = useCallback(_childCode => {
    setHasError(false)
    setApps([]);
    $this.current = {
      fetching: false,
      isEnd: false,
      skip: 0,
    };
    setChildCode(_childCode);

    report('C', source, {
      source: `${source}||${code}||${_childCode}`
    })
  }, [code]);

  useEffect(() => {
    createAxios().then(axios => {
      axios
        .get(GAME_CLASSES)
        .then(res => {
          if (res.data.status !== 0) throw new Error('no classes.');

          let result = res.data.data || [];
          result = result.filter(cls => cls.childClassList && cls.childClassList.length > 0);

          if (result.length <= 0) throw new Error('no classes.');

          let _code = result[0].code;
          if (query.get('code') && result.some(o => o.code === query.get('code'))) {
            _code = query.get('code');
          }
          if (history.action === 'POP') {
            const prevCode = sessionStorage.getItem('GAME_SEARCH_CODE');
            if (prevCode && result.some(o => o.code === prevCode)) {
              _code = prevCode;
              sessionStorage.removeItem('GAME_SEARCH_CODE');
            }
          }

          let _classes = result.find(o => o.code === _code).childClassList;
          let _childCode = _classes[0].childCode;
          if (
            query.get('childCode') &&
            _classes.some(o => o.childCode === query.get('childCode'))
          ) {
            _childCode = query.get('childCode');
          }

          if (history.action === 'POP') {
            const prevChildCode = sessionStorage.getItem('GAME_SEARCH_CHILDCODE');
            if (prevChildCode && _classes.some(o => o.childCode === prevChildCode)) {
              _childCode = prevChildCode;
              sessionStorage.removeItem('GAME_SEARCH_CHILDCODE');
            }
          }

          if (_code !== result[0].code || _childCode !== _classes[0].childCode) {
            setFold(false);
          }

          if (history.action === 'POP') {
            const prevFold = sessionStorage.getItem('GAME_SEARCH_FOLD');
            if (prevFold) {
              setFold(prevFold === '1');
              sessionStorage.removeItem('GAME_SEARCH_FOLD');
            }
          }

          setCode(_code);
          setChildCode(_childCode);
          setClasses(result);

          report('P', source, {
            source: `${source}||${_code}||${_childCode}`,
          });

          track(0, `${source}||${_code}||${_childCode}`);
        })
        .catch(e => {
          setHasError(true);
        });
    });
  }, []);

  useEffect(() => {
    if (code === null || childCode === null) return;
    if ($this.current.isEnd || $this.current.fetching) return;

    let limit = sessionStorage.getItem('GAME_SEARCH_LIMIT');
    if (limit !== null) {
      sessionStorage.removeItem('GAME_SEARCH_LIMIT');
    }

    $this.current.fetching = true;
    createAxios().then(axios => {
      axios
        .get(GAME_CLASS_APPS_LIST, {
          params: {
            code,
            childCode,
            limit: history.action === 'POP' && limit !== null ? limit : LIMIT,
            skip: $this.current.skip,
          },
        })
        .then(res => {
          $this.current.fetching = false;
          if (
            res.data.status !== 0 ||
            !res.data.data ||
            !res.data.data.apps ||
            res.data.data.apps.length <= 0
          )
            throw new Error('no apps.');

          !isReady && setIsReady(true);

          if ($this.current.skip === 0) {
            dispatch(scrollUse(history.action));
          }
          $this.current.skip += res.data.data.apps.length;
          setApps(apps => {
            let result = [...apps, ...res.data.data.apps];
            if (result.length >= res.data.data.count) {
              $this.current.isEnd = true;
            }
            return result;
          });
        })
        .catch(e => {
          $this.current.fetching = false;
          setHasError(true);
        });
    });
  }, [code, childCode, loadmore]);

  useEffect(() => {
    let scroller = document.querySelector('#container_content') || document.createElement('div');

    const _scrollHandle = e => {
      if (e.target.offsetHeight + e.target.scrollTop + 1 >= e.target.scrollHeight) {
        setLoadmore(Date.now());
      }
    };

    scroller.addEventListener('scroll', _scrollHandle);
    return () => {
      scroller.removeEventListener('scroll', _scrollHandle);
    };
  }, []);

  useEffect(() => {
    return () => {
      let limit = $this.current.skip;
      code && sessionStorage.setItem('GAME_SEARCH_CODE', code);
      childCode && sessionStorage.setItem('GAME_SEARCH_CHILDCODE', childCode);
      limit > 0 && sessionStorage.setItem('GAME_SEARCH_LIMIT', limit);
      sessionStorage.setItem('GAME_SEARCH_FOLD', fold ? '1' : '0');
    };
  }, [fold, code, childCode]);

  useEffect(() => {
    let _StartTime = Date.now();
    return () => {
      report('I', 'View_Time', {
        source: source,
        time: Math.ceil((Date.now() - _StartTime) / 1000),
      });
    };
  }, []);

  return (
    <div className={styles.Search}>
      {isReady && (
        <Filter
          classes={classes}
          code={code}
          setCode={toggleCode}
          childCode={childCode}
          setChildCode={toggleChildCode}
          fold={fold}
          setFold={setFold}
        />
      )}
      {!hasError && apps.length > 0 && <List source={source} code={code} childCode={childCode} apps={apps} />}
      {hasError && <LoadError offset={isReady ? -60 : 0} />}
      {!hasError && apps.length <= 0 && <Loading offset={isReady ? -60 : 0} />}
      {!hasError && apps.length > 0 && $this.current.fetching && (
        <p className="loading">正在加载中…</p>
      )}
      {!hasError && apps.length > 0 && $this.current.isEnd && (
        <p className="nothing">没有更多了~</p>
      )}
    </div>
  );
};
